import { render, staticRenderFns } from "./Intro-start.vue?vue&type=template&id=6724fcae"
import script from "./Intro-start.vue?vue&type=script&lang=js"
export * from "./Intro-start.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports